<template>
    <div>
        <b-row class="content-header">
            <b-col class="content-header-left mb-2" cols="12" md="9">
                <b-row class="breadcrumbs-top">
                    <b-col cols="12">
                        <h2 class="float-left mb-0">Resellers</h2>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-card>
                    <b-card-text
                        >Voucher codes are usually sent to your email after
                        payment is confirmed.
                        <b-link :to="{ name: 'voucher' }"
                            >Redeem a voucher</b-link
                        >
                        to upgrade your account.
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col md="12" cols="12">
                <b-card
                    class="purchase-notice-card"
                    title="Please Read Before You Purchase"
                >
                    <b-card-text class="text-left mb-75">
                        Please review these details to make sure the service
                        fits your needs.
                    </b-card-text>
                    <ul class="purchase-notice-list text-left mb-0">
                        <li>
                            <strong
                                >Host status &amp; service limits:</strong
                            >
                            Check the current
                            <b-link :to="{ name: 'status' }"
                                >host status and limits</b-link
                            >
                            before purchasing. Daily bandwidth, file size, and
                            link limits may apply and can change based on host
                            availability.
                        </li>
                        <li>
                            <strong>File availability:</strong>
                            Availability may vary by host and individual file.
                            Some files may require a separate subscription,
                            verification, or special access from the original
                            host and may not be downloadable through our
                            service.
                        </li>
                        <li>
                            <strong>Activation &amp; refunds:</strong>
                            Activated plans, keys, and vouchers cannot be
                            revoked and are non-refundable, except where
                            required by law.
                        </li>
                        <li>
                            <strong>Questions before purchasing?</strong>
                            We’re happy to help via
                            <a
                                href="https://t.me/ndt258"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Telegram</a
                            >
                            or
                            <a href="mailto:support@leechall.io"
                                >support@leechall.io</a
                            >.
                        </li>
                    </ul>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="items.length > 0">
            <b-col md="4" v-for="item in items" :key="item.id">
                <b-card>
                    <a :href="item.url" target="_blank"
                        ><h4 class="text-primary mb-1">{{ item.name }}</h4></a
                    >
                    <b-card-text
                        ><strong>Email:</strong> {{ item.email }}</b-card-text
                    >
                    <b-card-text
                        ><strong>Payment methods:</strong>
                        {{ item.payment_methods }}</b-card-text
                    >
                </b-card>
            </b-col>
        </b-row>
        <p v-else>{{ message }}</p>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
} from "bootstrap-vue";
export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BLink,
    },
    data() {
        return {
            items: [],
            message: "",
        };
    },
    created() {
        this.$store
            .dispatch("fetchResellers")
            .then((res) => {
                this.items = res.data.data;
                this.message = "We will update soon!";
            })
            .catch((err) => console.log(err));
    },
};
</script>

<style>
.purchase-notice-list {
    padding-left: 1.25rem;
}
.purchase-notice-card {
    background-color: #fff;
    border: 1px solid rgba(34, 41, 47, 0.125);
    border-left: 3px solid rgba(255, 159, 67, 0.75);
}
.purchase-notice-list li {
    margin-bottom: 0.5rem;
    line-height: 1.45;
}
.purchase-notice-list li:last-child {
    margin-bottom: 0;
}
</style>
